import { render, staticRenderFns } from "./emptyPage.vue?vue&type=template&id=3af768a6&scoped=true"
import script from "./emptyPage.vue?vue&type=script&lang=js"
export * from "./emptyPage.vue?vue&type=script&lang=js"
import style0 from "./emptyPage.vue?vue&type=style&index=0&id=3af768a6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af768a6",
  null
  
)

export default component.exports